<template>
    <v-dialog v-model="show_dialog" :persistent="true" max-width="1264px" scrollable>
        <v-card class="custom_card">

            <v-card-title>
                <span class="headline">{{header}}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text id="manage_expense_page">
                <div v-if="loading_data" class="pb-4">
                    <v-container fluid class="expense_loading"
                                 :class="[loading_data ? 'justify-center fill-height' : '']">
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    </v-container>
                </div>
                <div v-else class="pb-4">

                    <!--General info-->
                    <v-row dense>
                        <v-col cols="12" sm="6" md="6" lg="4">
                            <v-menu v-model="sale_date_menu" :close-on-content-click="false"
                                    max-width="290">
                                <template v-slot:activator="{ on }">
                                    <v-text-field name="date" type="text" class="custom_field"
                                                  :value="$Helper.methods.formatDate(item.date)"
                                                  :label="$t('general.date')" outlined readonly
                                                  :disabled="isFieldsDisabled" v-on="on" @blur="$v.item.date.$touch()"
                                                  @input="$v.item.date.$touch()" :error-messages="fieldErrors('date')">
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="item.date" no-title @change="sale_date_menu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-text-field name="amount" type="text" class="custom_field" v-model="item.amount"
                                          :label="$t('general.amount')" outlined clearable :disabled="isFieldsDisabled"
                                          @input="$v.item.amount.$touch()" @blur="$v.item.amount.$touch()"
                                          :error-messages="fieldErrors('amount')">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="4">
                            <v-select name="expense_type_id" class="custom_field" v-model="item.expense_type_id"
                                      :items="expense_types" :label="$t('expenses.type')" item-text="name"
                                      item-value="id" outlined clearable :disabled="isFieldsDisabled"
                                      @blur="$v.item.expense_type_id.$touch()" @input="$v.item.expense_type_id.$touch()"
                                      :error-messages="fieldErrors('expense_type_id')">
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field name="description" type="text" class="custom_field" v-model="item.description"
                                          :label="$t('general.description')" outlined clearable
                                          :disabled="isFieldsDisabled" @input="$v.item.description.$touch()"
                                          @blur="$v.item.description.$touch()"
                                          :error-messages="fieldErrors('description')">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                            <v-textarea name="comments" class="custom_field" v-model="item.comments"
                                        :label="$t('general.comments')" outlined clearable no-resize
                                        :disabled="isFieldsDisabled">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="elevation-1">
                <v-spacer></v-spacer>
                <v-btn color="primary" class="close_button" dark @click="closeDialog">
                    {{$t('general.close')}}
                </v-btn>
                <v-btn v-if="action === 'view' && $Helper.methods.canUserDoAction(canUpdateItem, isSuperAdmin, item)"
                       color="primary" class="update_button" dark @click="updateItem">
                    {{$t('general.update')}}
                </v-btn>
                <v-btn v-if="action !== 'view'" class="primary submit_button" dark :loading="is_loading"
                       @click="submitDialog()">
                    {{$t('general.save')}}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
    import SalesList from './SalesList.vue'
    import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'

    export default {
        props: {
            show: {type: Boolean, default: false},
            item_header: {type: String},
            item_action: {type: String},
            item_id: {type: Number}
        },
        components: {SalesList},
        mixins: [validationMixin],
        validations() {
            return {
                item: {
                    date: {required},
                    amount: {required},
                    expense_type_id: {required},
                    description: {required}
                }
            }
        },
        data: self => ({
            show_dialog: self.show,
            action: self.item_action,
            header: self.item_header,
            url: 'expenses',
            loading_data: false,
            is_loading: false,

            // actions permissions
            canUpdateItem: false,

            // look up data
            expense_types: [],

            // item
            sale_date_menu: false,
            item: {
                date: null,
                amount: null,
                expense_type_id: null,
                description: null,
                comments: null,
                created_at:null
            }
        }),
        computed: {
            isFieldsDisabled() {
                return this.action === 'view';
            },
            isSuperAdmin() {
                return this.$store.state.user_details.roles.map(obj => obj.name).indexOf('superadmin') > -1;
            }
        },
        async mounted() {
            this.canUpdateItem = await this.$store.dispatch('hasPermission', 'update_expense');

            // get expense types
            let expense_types = await this.$store.dispatch('apiRequest', {
                method: 'get', url: 'settings/expense_types'
            });
            this.expense_types = this.$Helper.methods.sortArrayOfObjects({array: expense_types.data, property: 'name'});
        },
        watch: {
            async show(val) {
                this.show_dialog = val;

                if (val) {
                    this.action = this.item_action;

                    // create
                    if (this.action === 'create') {

                        this.item.date = new Date().toISOString().substr(0, 10);

                        // view, update
                    } else {

                        let response = await this.$store.dispatch('apiRequest', {
                            method: 'get', url: `${this.url}/${this.item_id}`,
                        });

                        // successful response
                        if (!response.response) {

                            // set item data
                            this.$nextTick().then(() => {
                                for (let prop in this.item) {
                                    this.item[prop] = response.data[prop];
                                }
                            });

                            // error response
                        } else {
                            this.clearDialog();
                            this.$emit('close-dialog');
                        }
                    }
                }
            },
            item_action(val) {
                this.action = val;
            },
            item_header(val) {
                this.header = val;
            },
        },
        methods: {
            // form field errors
            fieldErrors(prop) {
                const errors = [];
                if (!this.$v.item[prop].$dirty) return errors;

                // general rules
                !this.$v.item[prop].required && errors.push(this.$t('validation.required'));

                return errors;
            },
            // clear dialog
            clearDialog() {
                this.$v.item.$reset();
                this.is_loading = false;

                for (let prop in this.item) {
                    this.item[prop] = null;
                }
            },
            // trigger close dialog event in parent component
            async closeDialog() {
                this.clearDialog();
                this.$emit('close-dialog');
            },
            // trigger submit dialog event in parent component
            async submitDialog() {
                this.$v.item.$touch();

                // item is valid
                if (!this.$v.item.$invalid) {

                    this.is_loading = true;

                    let response = await this.$store.dispatch('apiRequest', {
                        method: 'post',
                        url: this.action !== 'create' ? `${this.url}/${this.item_id}` : this.url,
                        data: this.item
                    });

                    this.is_loading = false;

                    // successful response
                    if (!response.response) {
                        this.$emit('submit-dialog');
                        this.clearDialog();
                    }
                }
            },
            // change view to update
            updateItem() {
                this.action = 'update';
                this.header = this.$t('expenses.update');
            }
        }
    }
</script>